import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Home as HomeIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="80vh"
      bgcolor="#f5f5f5"
      textAlign="center"
    >
      <Typography variant="h3" color="primary" gutterBottom>
        404
      </Typography>
      <Typography variant="h5" color="textSecondary" gutterBottom>
        ページが見つかりません
      </Typography>
      <Typography variant="body1" color="textSecondary" marginBottom={4}>
        お探しのページは存在しないか、エラーが発生しました。
      </Typography>
      <Button
        variant="contained"
        startIcon={<HomeIcon />}
        onClick={() => navigate("/")}
      >
        ホームに戻る
      </Button>
    </Box>
  );
};

export default NotFoundPage;